function GetPaginationQueryString(pagination) {
    if (!pagination)
        return '';

    let query = "sortCol=" + pagination.sortCol + "&sortType=" + pagination.sortType + "&pageIndex=" + pagination.pageIndex
        + "&pageSize=" + pagination.pageSize;
    return query;
}

export default GetPaginationQueryString;